import React from 'react';
import ReactDOM from 'react-dom';
import './index/css/index.css';
import './components/portal/uiElements/editorLayout/css/EditorLayout.css';
import './components/uiElements/socialFeeds/instagramFeed1/css/InstagramFeed1.css';
import './components/uiElements/socialFeeds/youtubeFeed1/css/YoutubeFeed1.css';
import App from './app/App';
import reportWebVitals from './index/reportWebVitals';

ReactDOM.render(
    <App />,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
